import React from "react";

const LazyResetPassword = React.lazy(() => import("./reset-password"));

const ResetPassword = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyResetPassword {...props} />
  </React.Suspense>
);

export default ResetPassword;
